'use strict';

// Redux front-end data store, replaces platforms/frontend/browser/src/store/store.js (reflux)

import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { routerReducer } from 'react-router-redux';
import promiseMiddleware from 'redux-promise-middleware';

import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'

import project from '../project/project-files/state/reducer';

const middleware = [
    thunk,
    promiseMiddleware(),
    // urlQueryMiddleware({ reducer: urlQueryReducer })
]
if (process.env.NODE_ENV !== 'production') {
    // middleware.push(createLogger())
}

// const PROJECT_LOCALSTORAGE_KEY = 'sp-project';

// // Load session from localStorage
// const localStorageSession = localStorage.getItem(PROJECT_LOCALSTORAGE_KEY);
let persistedState;
// if (localStorageSession) {
//     persistedState = {
//         project: JSON.parse(localStorageSession),
//     };
// }

// TODO only enable in DEV mode
let wrappedMiddleware;
if (Payload.release.dev && typeof window !== 'undefined') {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    wrappedMiddleware = composeEnhancers(applyMiddleware(...middleware));
} else {
    wrappedMiddleware = applyMiddleware(...middleware);
}

const reduxStore = createStore(combineReducers({
    project,
    routing: routerReducer, // add in state about routing via react-router-redux
}), persistedState, wrappedMiddleware);

let cached_session = reduxStore.getState().project;

// Persist session to localStorage
// reduxStore.subscribe(() => {
//     const project = reduxStore.getState().project;
//     if (project != cached_session) {
//         localStorage.setItem(PROJECT_LOCALSTORAGE_KEY, JSON.stringify(project));
//         cached_session = project;
//     }
// })

export default reduxStore;



// WEBPACK FOOTER //
// ./src/global/rstore.js